import { useEffect, useState } from "react";
import { useAppSelector } from "redux-share/hooks";
import { conditions } from "helpers";
import { ConditionName } from "interfaces";
import { shallowEqual } from 'react-redux'

const Equalizer = () => {

    let columnsCount = 320;
    if (window.innerWidth < 400) columnsCount = 68;
    else if (window.innerWidth < 520) columnsCount = 90;
    else if (window.innerWidth < 600) columnsCount = 120;
    else if (window.innerWidth < 800) columnsCount = 140;
    else if (window.innerWidth < 1100) columnsCount = 180;
    else if (window.innerWidth < 1200) columnsCount = 230;
    else if (window.innerWidth < 1300) columnsCount = 280;
    

    const columns = [...Array(columnsCount).keys() as any];

    const { play } = useAppSelector(({ controller: { play } }) => ({ play }), shallowEqual);
    const { settings } = useAppSelector(({ user: { settings } }) => ({ settings }), shallowEqual);

    const [number, setNumber] = useState<number>(0);
    const [coefficient, setCoefficient] = useState<number>(1);

    useEffect(() => {
        let interval = setInterval(() => setNumber((prevState) => prevState + 1),100)
        return () => clearInterval(interval);
    },[])

    useEffect(() => setCoefficient(conditions(ConditionName.isPlay) ? settings.volume : 0),[play]);

    useEffect(() => setCoefficient(settings.volume),[settings.volume]);

    return (
        <div className={`pl-w-full pl-h-full pl-px-4 pl-flex pl-items-end pl-gap-1 pl-mx-auto pl-absolute ${conditions(ConditionName.isComplexPortrait) ? "pl-top-0" : "pl-top-[-80px]"}`}>
            {columns.map((item:any,index:number) => <div className={`!pl-w-full pl-bg-main-highLight pl-rounded-[10px]`} style={{height:`${Math.random()*2*coefficient}px`, transition:"all 0.7s linear"}} key={index}></div>)}
        </div>
    )
}

export default Equalizer;